const initialState = {
  name: null,
  needReload: false,
  data: [],
  isError: false,
  isLoading: false,
  paging: null,
  search: {
    value: null
  },
  exportList: {
    isLoading: false
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case 'CLEAR_REDUCERS':
      return initialState;
    case 'CANCEL_GET_DATA':
      return initialState;
    case 'CLEAR_CORE_LIST_REDUCER':
      return initialState;
    case 'REFRESH_DATA':
      return {
        ...initialState,
        name: state.name,
        isLoading: true
      };
    case 'SET_DATA_NAME':
      return {
        ...state,
        name: action.name
      };
    case 'SET_DATA_SEARCH_VALUE':
      return {
        ...state,
        search: {
          ...state.search,
          value: action.value
        }
      };
    case 'SET_LIST_NEED_RELOAD':
      return {
        ...state,
        needReload: true
      };
    case 'UNSET_LIST_NEED_RELOAD':
      return {
        ...state,
        needReload: false
      };
    case 'GET_DATA':
      return {
        ...state,
        data: action.next ? state.data : initialState.data,
        paging: action.search ? initialState.paging : state.paging,
        isLoading: true,
        isError: false
      };
    case 'GET_DATA_SUCCESS': {
      const dataConcatenated = state.data.concat(action.data);

      return {
        ...state,
        data: dataConcatenated,
        paging: action.paging ? action.paging : state.paging,
        isLoading: false,
        isError: false
      };
    }
    case 'GET_DATA_ERROR':
      return {
        ...state,
        isLoading: false,
        isError: true
      };
    case 'EXPORT_LIST_DATA':
      return {
        ...state,
        exportList: {
          ...state.exportList,
          isLoading: true
        }
      };
    case 'EXPORT_LIST_DATA_SUCCESS':
      return {
        ...state,
        exportList: {
          ...state.exportList,
          isLoading: false
        }
      };
    case 'EXPORT_LIST_DATA_ERROR':
      return {
        ...state,
        exportList: {
          ...state.exportList,
          isLoading: false
        }
      };
    default:
      return state;
  }
};
